"use client";

import { useState } from "react";
import { BlockRenderer } from "@/components/block-renderer";
import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import type { DietListingFaqType } from "@/features/diets/types/diet-listing-faq.type";
import { useCarouselDrag } from "@/lib/hooks/use-carousel-drag";
import { cn } from "@/lib/utils";

export const DietsListingFaq = ({ data }: { data: DietListingFaqType }) => {
  const [api, setApi] = useState<CarouselApi>();

  const isDragging = useCarouselDrag(api);

  return (
    <Carousel
      className={cn("max-sm:-mx-4 max-sm:[&>div]:pl-4", {
        "lg:pointer-events-none": data.faq?.length && data.faq.length <= 4,
      })}
      opts={{
        align: "start",
        dragFree: true,
      }}
      setApi={setApi}
    >
      <CarouselContent className="last:mr-12 lg:last:mr-0">
        {data.faq.map((faq) => {
          return (
            <CarouselItem
              className="flex max-w-full md:basis-[45%] xl:basis-[31%]"
              key={`listing-faq-${faq.id}`}
            >
              <div className={cn("rounded-lg bg-brand-grey4 p-6")}>
                <p className="mb-4 font-medium text-xl leading-7">
                  {faq.title}
                </p>
                <BlockRenderer content={faq.content} />
              </div>
            </CarouselItem>
          );
        })}
      </CarouselContent>
      {!isDragging && (
        <>
          <CarouselPrevious className="h-14 w-14 translate-x-6 rounded-md border-0 drop-shadow-[2px_12px_7px_hsla(0,0%,0%,0.06)] disabled:invisible md:translate-x-2" />
          <CarouselNext className="z-10 h-14 w-14 -translate-x-6 rounded-md border-0 drop-shadow-[2px_12px_7px_hsla(0,0%,0%,0.06)] disabled:invisible md:mr-0 md:-translate-x-2" />
        </>
      )}
    </Carousel>
  );
};
